<div class="modal-body width-600 height-600">
  <div class="layout-auto-1-auto">
    <span class="modal-header">
      {{editMode ? 'Notiz bearbeiten' : 'Neue Notiz'}}
    </span>
    <editor class="grid-full-height" *ngIf="MCEinit" [(ngModel)]="content" [init]="MCEinit"></editor>
    <div class="spawn-modal-actions">
      <button (click)="close()" class="md-btn">
        Abbrechen
      </button>
      <button (click)="save()" [disabled]="disabled" class="md-btn">
        {{editMode ? 'Ändern' : 'Erstellen'}}
      </button>
    </div>
  </div>
</div>
